import React from 'react';
import classNames from 'classnames';
import { Spacer } from '@cleartrip/bento';

import './_list.scss';

function ListItem({ className, children, listStyle, style, ...otherProps }) {
	const listClassName = classNames('mb-1 fs-3 lh-copy lh-copy--xs ls-disc list c-neutral-700', className);
	return (
		<div className='flex flex-start'>
			{listStyle !== 'none' && <Spacer className='mr-8 mr-6--xs' />}
			<li style={{ listStyleType: listStyle, lineHeight: 1.5 }} className={listClassName} {...otherProps}>
				{children}
			</li>
		</div>
	);
}

ListItem.defaultProps = {
	listStyle: 'disc',
};

export default ListItem;
